export default [
  {
    name: "signin",
    component: require("../../views/SigninView.vue").default,
    path: "/",
    meta: {
      layout: "auth",
      auth: false,
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: require("../../components/NotFound.vue").default,
    meta: {
      layout: "auth",
      auth: false,
    },
  },
];
